import { color, ColorProps } from '@utils/styled/color';
import { exceptionList } from '@utils/styled/exceptionList';
import { spinAnimation } from '@utils/styled/spinAnimation';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import {
  compose,
  display,
  DisplayProps,
  fontSize,
  FontSizeProps,
} from 'styled-system';

export type IconTypes =
  | 'exit'
  | 'copy'
  | 'chevron-down'
  | 'calendar'
  | 'plane'
  | 'store'
  | 'ellipsis-h'
  | 'circle-error-solid'
  | 'check'
  | 'circle-error'
  | 'circle-success'
  | 'circle-warning'
  | 'select'
  | 'pen'
  | 'trash'
  | 'info'
  | 'circle-close-solid'
  | 'spinner';

interface StyledProps extends FontSizeProps, DisplayProps, ColorProps {
  rotate?: number;
  spin?: boolean;
}

export interface IconProps extends StyledProps {
  icon: IconTypes;
}

const StyledIcon = styled.i.withConfig<StyledProps>({
  shouldForwardProp: (prop, validator) =>
    !exceptionList.includes(prop) && validator(prop),
})`
  transition: transform 0.25s;
  display: inline-block;
  transform: ${({ rotate = 0 }) => `rotate(${rotate}deg)`};
  ${({ spin }) => spin && spinAnimation()};
  ${compose(color, fontSize, display)}
  transform-origin: center;
`;

export const Icon: FunctionComponent<IconProps> = ({ icon, ...props }) => {
  return <StyledIcon className={`gsif-${icon}`} {...props} />;
};
